import { render, staticRenderFns } from "./apply-for-leave.vue?vue&type=template&id=629e0514&scoped=true&"
import script from "./apply-for-leave.vue?vue&type=script&lang=js&"
export * from "./apply-for-leave.vue?vue&type=script&lang=js&"
import style0 from "./apply-for-leave.vue?vue&type=style&index=0&id=629e0514&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629e0514",
  null
  
)

export default component.exports